// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5g-1";
export var standaloneTable = "_5g-0";